
<div class="d-flex align-center">
  <!-- table icon -->
  <div v-if="showIcon" class="d-flex align-center">
    <img src="/assets/icon-table.png" style="width: 16px; height: 16px">
  </div>
  <!-- 이름 (일반 모드) -->
  <div v-if="!isModifyingName">
    <v-hover v-slot="{ hover }">
      <div class="d-flex align-center">
        <!-- title -->
        <div :class="showIcon ? 'pl-2' : ''" style="font-size: 15px">
          <div v-if="tableDatas[tableId].title">
            {{ tableDatas[tableId].title }}
          </div>
          <div v-else style="color: #90A4AE">
            {{ tableId+1 }}
          </div>
        </div>
        <div v-if="!hover || !canEdit" style="width: 20px"></div>
        <!-- 수정 버튼 -->
        <v-tooltip v-if="hover && canEdit" bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on" class="d-flex align-center ml-1" style="width: 20px; height: 20px">
              <div @click.stop="clickModifyNameBtn()"
                class="d-flex align-center justify-center"
                :class="$store.getters.permissionLevel < 1 ? 'disabled-icon-btn' : 'default-icon-btn'"
                style="width: 18px; height: 18px"
              >
                <v-icon style="font-size: 15px">mdi-pencil</v-icon>
              </div>
            </div>
          </template>
          <span>{{ $store.getters.permissionLevel >= 1 ? '수정' : '수정 권한이 없습니다.' }}</span>
        </v-tooltip>
      </div>
    </v-hover>
  </div>
  <!-- 이름 (수정 모드) -->
  <div v-else class="d-flex align-center" style="width: 100%" v-click-outside="cancelModifyName">
    <!-- 수정창 -->
    <v-text-field
      v-model="tableDatas[tableId].title" @keyup.enter="modifyName()" @keyup.esc="cancelModifyName()" :style="{fontSize: '15px'}"
      class="modify-text-input mt-0 pt-0" style="width: 100%" hide-details autofocus color="#0D0E17"
    ></v-text-field>
    <!-- 확정 버튼 -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on" @click.stop="modifyName()"
          class="d-flex align-center justify-center ml-1"
          :class="!tableDatas[tableId].title || (tableDatas[tableId].title && !tableDatas[tableId].title.trim()) ? 'disabled-icon-btn' : 'default-icon-btn'"
          style="min-width: 18px; max-width: 18px; height: 18px"
        >
          <v-icon style="font-size: 15px">mdi-check</v-icon>
        </div>
      </template>
      <span>확인</span>
    </v-tooltip>
    <!-- 취소 버튼 -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on" @click.stop="cancelModifyName()"
          class="default-icon-btn d-flex align-center justify-center ml-1"
          style="min-width: 18px; max-width: 18px; height: 18px"
        >
          <v-icon style="font-size: 15px">mdi-close</v-icon>
        </div>
      </template>
      <span>취소</span>
    </v-tooltip>
  </div>
</div>
